export const fontDefault = "'Neue Montreal', system-ui";
export const fontStackTTHoves = `"TT Hoves", ${fontDefault}`;
export const fontMonospaced = "'SFMono-Regular', Menlo, Monaco, Consolas, monospace !important";
